import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=2fcaa99c&scoped=true&"
import script from "./QuestionContent.vue?vue&type=script&lang=js&"
export * from "./QuestionContent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=2fcaa99c&lang=scss&scoped=true&"
import style1 from "./QuestionContent.vue?vue&type=style&index=1&id=2fcaa99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcaa99c",
  null
  
)

export default component.exports